import React from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import { omit } from 'lodash';

import { Breadcrumb } from '@shared/components/bootstrap/breadcrumb';

import { Spinner } from '@admin/components/spinner';
import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useAccountAddressEditQuery } from '@admin/schema';

import { AccountAddressForm } from './form';

export const Edit: React.FC = () => {
  useTitle('Edit Address');
  const { accountID, addressID } = useParams<{ accountID: string; addressID: string }>();
  const navigate = useNavigate();
  const { data } = useAccountAddressEditQuery({ client, variables: { accountID, addressID } });
  if (!data) return <Spinner />;

  const onSave = (address: { id: string }) => {
    navigate(`/accounts/${accountID}/addresses/${address.id}`);
  };

  const account = data.account;
  const defaults = {
    ...omit(data.account.address, '__typename', 'details'),
    ...omit(data.account.address.details, '__typename'),
  };

  return (
    <>
      <h1 className="page-header text-overflow">
        <Breadcrumb>
          <Breadcrumb.Item>
            <NavLink to="/accounts">Accounts</NavLink>
          </Breadcrumb.Item>{' '}
          <Breadcrumb.Item>
            <NavLink to={`/accounts/${accountID}`}>
              #{account.number} ({account.customer.name})
            </NavLink>
          </Breadcrumb.Item>{' '}
          <Breadcrumb.Item>
            <NavLink to={`/accounts/${accountID}/addresses/${addressID}`}>Address</NavLink>
          </Breadcrumb.Item>{' '}
          <Breadcrumb.Item active>Edit</Breadcrumb.Item>
        </Breadcrumb>
      </h1>

      <AccountAddressForm accountID={accountID} addressID={addressID} defaults={defaults} onSave={onSave} />
    </>
  );
};
